module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.withAccreditation && _vm.result && _vm.result.data) ? _c('div', {
    staticClass: "caption"
  }, [_c('div', {
    staticClass: "white--text caption pl-3 py-0 my-0"
  }, [_vm._v("Backgrounds by Unsplash.\n      "), _c('a', {
    staticClass: "grey--text",
    attrs: {
      "href": _vm.result.data.links.html + "?utm_source=AppointmentGuru&utm_medium=referral&utm_campaign=api-credit",
      "target": "_blank"
    }
  }, [_vm._v("image")]), _vm._v("\n        by\n      "), _c('a', {
    staticClass: "grey--text",
    attrs: {
      "href": _vm.result.data.user.links.html + "?utm_source=AppointmentGuru&utm_medium=referral&utm_campaign=api-credit",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.result.data.user.name))])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ed7bd49","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RandomSplash.vue
// module id = 1374
// module chunks = 9